import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { DP } from "../common/types";

interface Props extends DP {}

const dotVariants = {
  active: {
    scale: [0.3, 1, 0.3],
    transition: {
      repeat: Infinity,
    },
  },
};

const SpinnerDots = (props: Props) => {
  return (
    <AnimWrapper
      className={props.className}
      animate="active"
      variants={{
        active: {
          transition: {
            repeat: Infinity,
            staggerChildren: 0.5,
            when: "afterChildren",
          },
        },
      }}
    >
      <AnimDot variants={dotVariants} />
      <AnimDot variants={dotVariants} />
      <AnimDot variants={dotVariants} />
    </AnimWrapper>
  );
};

const AnimWrapper = styled(motion.div)(() => [tw`flex space-x-1`]);
const AnimDot = styled(motion.div)(() => [
  tw`w-[1rem] aspect-square rounded-circle bg-pink-400`,
]);

export default styled(SpinnerDots)``;
